export const content = state => state.content;
